import { Button, CopyButton, Modal } from "@nabble/ui";

/** A single-use link whose email couldn't be sent, and who it was meant for. */
export interface UnsentLink {
  link: string;
  email: string;
}

/** Shows an unsent single-use link so the administrator can share it another way. */
export function ShareLinkDialog({ unsent, onClose }: { unsent: UnsentLink; onClose: () => void }): React.JSX.Element {
  return (
    <Modal
      open
      icon="mail"
      tone="warning"
      title="Share the link another way"
      description={`We couldn't send the email to ${unsent.email}. Copy the link and share it securely.`}
      onClose={onClose}
      actions={<Button label="Done" onClick={onClose} />}
    >
      <div className="nb-secret">
        <code>{unsent.link}</code>
        <CopyButton value={unsent.link} size="sm" />
      </div>
      <p className="nb-help">The link works only once and expires.</p>
    </Modal>
  );
}
